import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
declare let google: any;
declare let L;

@Component({
  selector: 'app-trip-mirror-map',
  templateUrl: './trip-mirror-map.component.html',
  styleUrls: ['./trip-mirror-map.component.scss']
})
export class TripMirrorMapComponent implements OnInit {
  isOSMFalg: boolean = false;
  map: any = {};
  mapCenter: any;
  marker: any;
  empmarkers: any[] = [];
  tripData: any;
  mapType: any;
  showGoogleMap = false;
  googleMapInitialized = false;
  mapLoadAttempts = 0;
  maxMapLoadAttempts = 50;

  constructor(
    private serviceLocalStorage: ServiceLocalStorage,
    private apiService: ApiService,
    public dialogRef: MatDialogRef<TripMirrorMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.tripData = data;
    }
  }

  ngOnInit() {
    this.resolveMapTypeAndInit();
    // this.mapType = this.serviceLocalStorage.getMapType();
    // if (this.mapType === AppConstants.OSRM) {
    //   this.isOSMFalg = true;
    //   setTimeout(() => {
    //     this.loadOSmap();
    //     this.showTripOnOSMap();
    //   }, 10);
    // } else {
    //   this.isOSMFalg = false;
    //   setTimeout(() => { ... google map ... this.showTripsOnMap() }, 10);
    // }
  }

  private resolveMapTypeAndInit(): void {
    const clientCode = localStorage.getItem('clientCode');
    if (!clientCode) {
      this.initMapByClientFlag();
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        this.initMapByClientFlag();
      },
      () => this.initMapByClientFlag()
    );
  }

  private initMapByClientFlag(): void {
    this.showGoogleMap = this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    this.isOSMFalg = !this.showGoogleMap;
    this.googleMapInitialized = false;
    this.mapLoadAttempts = 0;
    setTimeout(() => {
      if (this.isOSMFalg) {
        this.loadOSmap();
        this.showTripOnOSMap();
      } else {
        this.loadgmap();
      }
    }, 10);
  }

  loadgmap() {
    if (!this.showGoogleMap) {
      return;
    }
    if (this.googleMapInitialized) {
      this.showTripsOnMap();
      return;
    }
    const mapEl = document.getElementById('map');
    if (!mapEl || typeof google === 'undefined' || (!google.maps?.Map && !google.maps?.importLibrary)) {
      if (++this.mapLoadAttempts < this.maxMapLoadAttempts) {
        setTimeout(() => this.loadgmap(), 100);
      }
      return;
    }
    this.initGoogleMapAsync(mapEl);
  }

  private async initGoogleMapAsync(mapEl: HTMLElement): Promise<void> {
    try {
      let MapClass = google.maps?.Map;
      if (google.maps?.importLibrary) {
        const mapsLib = await google.maps.importLibrary('maps') as any;
        MapClass = mapsLib.Map;
      }
      if (!MapClass) {
        this.loadgmap();
        return;
      }
      this.mapCenter = { lat: 13.0196, lng: 77.5968 };
      this.map = new MapClass(mapEl, {
        center: this.mapCenter,
        zoom: 12,
        draggable: true,
        zoomControl: true,
        gestureHandling: 'greedy'
      });
      this.googleMapInitialized = true;
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        google.maps.event.trigger(this.map, 'resize');
        this.showTripsOnMap();
      });
    } catch (error) {
      console.error('Google Map init failed', error);
      this.loadgmap();
    }
  }

  showTripsOnMap() {
    let waypoints: any = [];
    let location;
    if (this.tripData.tripDetails.shift.logType == "IN") {
      this.tripData.tripDetails.tripUsers.forEach((user) => {
        location = {
          lat: user.landmark.latitude,
          lng: user.landmark.longitude
        };
        waypoints.push({ location: location, stopover: true });
      });
      location = {
        lat: this.tripData.tripDetails.site.landmark.latitude,
        lng: this.tripData.tripDetails.site.landmark.longitude
      };
      waypoints.push({ location: location, stopover: true });
    } else {
      location = {
        lat: this.tripData.tripDetails.site.landmark.latitude,
        lng: this.tripData.tripDetails.site.landmark.longitude
      };
      waypoints.push({ location: location, stopover: true });
      this.tripData.tripDetails.tripUsers.forEach((user) => {
        location = {
          lat: user.landmark.latitude,
          lng: user.landmark.longitude
        };
        waypoints.push({ location: location, stopover: true });
      });
    }
    waypoints.forEach((location, p) => {
      if (this.tripData.tripDetails.shift.logType === "IN") {
        if (p === this.tripData.tripDetails.tripUsers.length) {
          this.markSite(this.tripData.tripDetails.site);
          return;
        }
      } else {
        if (p === 0) {
          this.markSite(this.tripData.tripDetails.site);
          return;
        }
      }
      if (this.tripData.tripDetails.shift.logType === "IN") {
        if (p <= this.tripData.tripDetails.tripUsers.length) {
          this.plotEmployee(location.location, this.tripData.tripDetails.tripUsers[p].gender, this.tripData.tripDetails.tripUsers[p].displayName,
            this.tripData.tripDetails.tripUsers[p].address, this.tripData.tripDetails.tripUsers[p].routedOrder, p + 1);
        }
      } else {
        if (p - 1 <= this.tripData.tripDetails.tripUsers.length) {
          this.plotEmployee(location.location, this.tripData.tripDetails.tripUsers[p - 1].gender, this.tripData.tripDetails.tripUsers[p - 1].displayName,
            this.tripData.tripDetails.tripUsers[p - 1].address, this.tripData.tripDetails.tripUsers[p - 1].routedOrder, p);
        }
      }
    })
    let origin: any;
    let destination: any;
    origin = {
      lat: waypoints[0].location.lat,
      lng: waypoints[0].location.lng
    };
    destination = {
      lat: waypoints[waypoints.length - 1].location.lat,
      lng: waypoints[waypoints.length - 1].location.lng
    };
    // Exclude origin/destination from waypoints — duplicating them skews Google Directions.
    const middleWaypts = waypoints.slice(1, -1).map(wp => ({
      lat: wp.location.lat,
      lng: wp.location.lng
    }));
    this.drawShortestGoogleRoute(origin, destination, middleWaypts);
  }

  /** Shortest driving path — same strategy as BE Routes API computeRoutes. */
  private async drawShortestGoogleRoute(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[] = []
  ): Promise<void> {
    try {
      const drawn = await this.drawShortestRouteViaMapsJs(origin, destination, middlePoints)
        || await this.drawShortestRouteViaRestApi(origin, destination, middlePoints);
      if (drawn) {
        return;
      }
    } catch (error) {
      console.warn('Shortest Routes API path failed; falling back to Directions alternatives', error);
    }
    this.drawShortestRouteViaDirectionsService(origin, destination, middlePoints);
  }

  private async drawShortestRouteViaMapsJs(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): Promise<boolean> {
    if (!google.maps?.importLibrary) {
      return false;
    }
    const routesLib = await google.maps.importLibrary('routes') as any;
    const RouteClass = routesLib?.Route;
    if (!RouteClass?.computeRoutes) {
      return false;
    }
    const request: any = {
      origin,
      destination,
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      fields: ['path', 'distanceMeters', 'polyline']
    };
    if (middlePoints.length) {
      request.intermediates = middlePoints.map(point => ({ location: point }));
    }
    const { routes } = await RouteClass.computeRoutes(request);
    const shortest = this.pickShortestRouteByDistanceMeters(routes);
    if (!shortest) {
      return false;
    }
    let path = shortest.path;
    if (!path?.length && shortest.polyline?.encodedPolyline) {
      path = this.decodeGoogleEncodedPolyline(shortest.polyline.encodedPolyline);
    }
    if (!path?.length) {
      return false;
    }
    this.renderGoogleRoutePath(path);
    return true;
  }

  private async drawShortestRouteViaRestApi(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): Promise<boolean> {
    const apiKey = this.getGoogleMapsApiKey();
    if (!apiKey) {
      return false;
    }
    const body: any = {
      origin: { location: { latLng: { latitude: origin.lat, longitude: origin.lng } } },
      destination: { location: { latLng: { latitude: destination.lat, longitude: destination.lng } } },
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      languageCode: 'en-US',
      units: 'METRIC'
    };
    if (middlePoints.length) {
      body.intermediates = middlePoints.map(point => ({
        location: { latLng: { latitude: point.lat, longitude: point.lng } }
      }));
    }
    const response = await fetch('https://routes.googleapis.com/directions/v2:computeRoutes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': apiKey,
        'X-Goog-FieldMask': 'routes.distanceMeters,routes.polyline.encodedPolyline'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      console.warn('Routes REST API failed', response.status, await response.text());
      return false;
    }
    const payload = await response.json();
    const shortest = this.pickShortestRouteByDistanceMeters(payload?.routes);
    const encoded = shortest?.polyline?.encodedPolyline;
    if (!encoded) {
      return false;
    }
    this.renderGoogleRoutePath(this.decodeGoogleEncodedPolyline(encoded));
    return true;
  }

  private drawShortestRouteViaDirectionsService(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): void {
    const directionsService = new google.maps.DirectionsService();
    const directionsDisplay = new google.maps.DirectionsRenderer({
      draggable: false,
      polylineOptions: { strokeWeight: 7, strokeColor: '#242c81' },
      suppressMarkers: true
    });
    directionsDisplay.setMap(this.map);
    directionsService.route({
      origin,
      destination,
      waypoints: middlePoints.map(point => ({ location: point, stopover: true })),
      optimizeWaypoints: false,
      travelMode: 'DRIVING',
      avoidFerries: true,
      avoidHighways: false,
      avoidTolls: false,
      provideRouteAlternatives: middlePoints.length === 0
    }, (response, status) => {
      if (status === 'OK' && response?.routes?.length) {
        const shortestRoute = response.routes.reduce((shortest, route) => {
          const shortestDist = this.getDirectionsRouteDistanceMeters(shortest);
          const routeDist = this.getDirectionsRouteDistanceMeters(route);
          return routeDist < shortestDist ? route : shortest;
        }, response.routes[0]);
        response.routes = [shortestRoute];
        directionsDisplay.setDirections(response);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
  }

  private pickShortestRouteByDistanceMeters(routes: any[] | undefined): any | null {
    if (!routes?.length) {
      return null;
    }
    return routes.reduce((shortest, route) => {
      const shortestDist = shortest?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      const routeDist = route?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      return routeDist < shortestDist ? route : shortest;
    }, routes[0]);
  }

  private getDirectionsRouteDistanceMeters(route: any): number {
    return (route?.legs || []).reduce((sum, leg) => sum + (leg?.distance?.value || 0), 0);
  }

  private renderGoogleRoutePath(path: any[]): void {
    if (!path?.length || !this.map) {
      return;
    }
    new google.maps.Polyline({
      path,
      strokeColor: '#242c81',
      strokeWeight: 7,
      strokeOpacity: 1,
      map: this.map
    });
    const bounds = new google.maps.LatLngBounds();
    path.forEach(point => bounds.extend(point));
    this.map.fitBounds(bounds);
  }

  private getGoogleMapsApiKey(): string | null {
    const scripts = Array.from(document.getElementsByTagName('script'));
    const mapsScript = scripts.find(script => script.src?.includes('maps.googleapis.com/maps/api/js'));
    if (!mapsScript?.src) {
      return null;
    }
    try {
      return new URL(mapsScript.src).searchParams.get('key');
    } catch {
      return null;
    }
  }

  private decodeGoogleEncodedPolyline(encoded: string): { lat: number; lng: number }[] {
    let index = 0;
    let lat = 0;
    let lng = 0;
    const coordinates: { lat: number; lng: number }[] = [];
    while (index < encoded.length) {
      let shift = 0;
      let result = 0;
      let byte: number;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lat += (result & 1) ? ~(result >> 1) : (result >> 1);

      shift = 0;
      result = 0;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lng += (result & 1) ? ~(result >> 1) : (result >> 1);

      coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return coordinates;
  }

  loadOSmap() {
    this.map = L.map("map", {
      fullscreenControl: true,
      dragging: true
    }).setView([this.tripData.tripDetails.site.landmark.latitude, this.tripData.tripDetails.site.landmark.longitude], 13);
    L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);
    setTimeout(() => this.map.invalidateSize(), 0);
  }

  showTripOnOSMap() {
    let wps = [];
    if (this.tripData.tripDetails.shift.logType == "IN") {
      this.tripData.tripDetails.tripUsers.forEach((wp) => {
        wps.push(L.latLng(wp.landmark.latitude, wp.landmark.longitude)
        );
      });
      wps.push(L.latLng(this.tripData.tripDetails.site.landmark.latitude, this.tripData.tripDetails.site.landmark.longitude));
    } else {
      wps.push(L.latLng(this.tripData.tripDetails.site.landmark.latitude, this.tripData.tripDetails.site.landmark.longitude));
      this.tripData.tripDetails.tripUsers.forEach((wp) => {
        wps.push(L.latLng(wp.landmark.latitude, wp.landmark.longitude));
      });
    }
    let r = L.Routing.control({
      serviceUrl: AppConstants.OSM_ROUTING_URL,
      showAlternatives: false,
      lineOptions: {
        styles: [
          {
            color: "#242c81",
            weight: 7
          }
        ]
      },
      fitSelectedRoutes: true,
      waypointMode: "connect",
      addWaypoints: false,
      draggableWaypoints: false,
      autoRoute: true,
      reverseWaypoints: false,
      altLineOptions: {
        styles: [
          {
            color: "#ed6852",
            weight: 3
          }
        ]
      },
      show: true,
      routeWhileDragging: false,
      createMarker: (i, wp, nWps) => {
        if (this.tripData.tripDetails.shift.logType === "IN") {
          if (i === this.tripData.tripDetails.tripUsers.length) {
            let m = L.marker(wp.latLng, {
              icon: L.icon({
                iconUrl: "./assets/images/company.png",
                iconSize: [40, 40]
              }),
              title: this.tripData.tripDetails.site.landmark.landmark
            });
            return m;
          }
        } else {
          if (i === 0) {
            let m = L.marker(wp.latLng, {
              icon: L.icon({
                iconUrl: "./assets/images/company.png",
                iconSize: [40, 40]
              }),
              title: this.tripData.tripDetails.site.landmark.landmark
            });
            return m;
          }
        }
        if (this.tripData.tripDetails.shift.logType === "IN") {
          if (i <= this.tripData.tripDetails.tripUsers.length) {
            let m = L.marker(wp.latLng, {
              icon: L.icon({
                iconUrl:
                  this.tripData.tripDetails.tripUsers[i].gender === "Female" ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                iconSize: [65, 70]
              }),
              title: this.tripData.tripDetails.tripUsers[i].displayName
            }).bindTooltip(i + 1 + "", {
              permanent: true,
              direction: "left",
              offset: L.point(-10, 0)
            })
              .openTooltip();
            return m;
          }
        } else {
          if (i - 1 <= this.tripData.tripDetails.tripUsers.length) {
            let m = L.marker(wp.latLng, {
              icon: L.icon({
                iconUrl:
                  this.tripData.tripDetails.tripUsers[i - 1]
                    .gender === "Female" ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                iconSize: [65, 70]
              }),
              title: this.tripData.tripDetails.tripUsers[i - 1].displayName
            })
              .bindTooltip(i + "", {
                permanent: true,
                direction: "left",
                offset: L.point(-10, 0)
              })
              .openTooltip();
            return m;
          }
        }

      }
    }).addTo(this.map);
    r.setWaypoints(wps);
    r.hide();
  }

  markSite(site) {
    let sitecordinates = new google.maps.LatLng(
      site.landmark.latitude,
      site.landmark.longitude
    );
    let path = "./assets/images/company.png";
    this.marker = new google.maps.Marker({
      position: sitecordinates,
      icon: {
        url: path,
        scaledSize: new google.maps.Size(40, 40)
      },
      map: this.map,
      title: site.siteName
    });
  }

  plotEmployee(latlng, gender, name, address, routedOrder, index) {
    let path = "./assets/images/livetracking/maleloc.svg";
    if (gender == "Female") {
      path = "./assets/images/livetracking/femaleloc.svg";
    }
    let empmarker = new google.maps.Marker({
      position: latlng,
      title: name + " - " + address,
      map: this.map,
      animation: google.maps.Animation.DROP,
      icon: {
        url: path,
        scaledSize: new google.maps.Size(50, 50),
        labelOrigin: new google.maps.Point(18, -8)
      },
      label: {
        text: "P" + index,
        color: "black",
        fontWeight: "bold",
        fontSize: "12px"
      }
    });
    this.empmarkers.push(empmarker);
  }

  setNewMarker(location, userName) {
    this.marker = new google.maps.Marker({
      position: location,
      draggable: true,
      animation: google.maps.Animation.DROP,
      map: this.map
    });
  }

  close() {
    this.dialogRef.close();
  }

}
